// extracted by mini-css-extract-plugin
module.exports = {"title":"title_title__22lzZ","title_divers":"title_title_divers__2GQrw","title_icon":"title_title_icon__2dwKD"};